import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthorizationSelectors } from '@next/core-lib/authorization';
import { CustomerGuard } from '@next/core-lib/relationships';
import { Store, select } from '@ngrx/store';
import { of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HistoryGuard {
  private readonly store = inject<Store<History>>(Store);
  private readonly customerGuard = inject(CustomerGuard);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.store.pipe(
      select(AuthorizationSelectors.hasGlobalAdministratorRole),
      take(1),
      switchMap((isGlobalAdministrator) => {
        if (isGlobalAdministrator) {
          return of(true);
        }

        return this.customerGuard.canActivate(route, state);
      }),
    );
  }
}
